import { render, staticRenderFns } from "./ItemSubGroup.vue?vue&type=template&id=22cc5628"
import script from "./ItemSubGroup.vue?vue&type=script&lang=js"
export * from "./ItemSubGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports